@if (!stepperFlag) {
  <div class="px-8 pb-4">
    <div class="pt-20">
      <div class="flex flex-row-reverse">
        <div>
          <button [disabled]="!fieldsPopulated" type="button" class="btn-theme-primary" (click)="toggleReportpage()">
            Create New Report
          </button>
        </div>       
      </div>
    </div>
  </div>
}

@if (initiateFlag) {
  <app-reports-table></app-reports-table>
}
@if (stepperFlag) {
  <app-stepper-screen></app-stepper-screen>
}